/** Data attribute to indicate that a download link should be tracked. */
export const TRACK_DOWNLOAD_ATTR = 'data-track-download';
/** Data attribute to indicate that a referral link should be tracked. */
export const TRACK_REFERRAL_ATTR = 'data-track-referral';

export const DOWNLOAD_ATTR_PROFESSIONAL_TITLE = 'data-professional';
export const DOWNLOAD_ATTR_FILE_TITLE = 'data-file-title';
export const DOWNLOAD_ATTR_FILE_ID = 'data-file-id';
export const DOWNLOAD_ATTR_PROFESSIONAL_ID = 'data-professional-id';
export const DOWNLOAD_ATTR_PRODUCT_ID = 'data-product-id';
export const DOWNLOAD_ATTR_PROJECT_ID = 'data-project-id';
/**
 * Which surface handed the file over — the `DownloadSurface` the gated path
 * already reports as `Source`. Set it on tracked anchors too, or an entitled
 * reader's download (which renders as a plain link, not a gated button) lands
 * with no surface on it, and `Source` is one of only two keys that survive the
 * warehouse's column flattening.
 */
export const DOWNLOAD_ATTR_SURFACE = 'data-download-surface';

export const REFERRAL_ATTR_PROFESSIONAL_ID = 'data-professional-id';
export const REFERRAL_ATTR_PROFESSIONAL_TITLE = 'data-professional';
export const REFERRAL_ATTR_ITEM_ID = 'data-item-id';
/** Which CTA surface produced the referral click (e.g. ProductHeaderCTA). */
export const REFERRAL_ATTR_SOURCE = 'data-referral-source';

export default {
    TRACK_DOWNLOAD_ATTR,
    TRACK_REFERRAL_ATTR,
    DOWNLOAD_ATTR_PROFESSIONAL_TITLE,
    DOWNLOAD_ATTR_FILE_TITLE,
    DOWNLOAD_ATTR_FILE_ID,
    DOWNLOAD_ATTR_PROFESSIONAL_ID,
    DOWNLOAD_ATTR_PRODUCT_ID,
    DOWNLOAD_ATTR_PROJECT_ID,
    DOWNLOAD_ATTR_SURFACE,
    REFERRAL_ATTR_PROFESSIONAL_TITLE,
    REFERRAL_ATTR_ITEM_ID,
    REFERRAL_ATTR_SOURCE,
};
